/**
 * Which kind of device -- the one fact that decides which store's badge the
 * install hint offers.
 *
 * Pulled out of the component so the detection can be tested against real user
 * agent strings, which is the only way to be sure about a rule made entirely of
 * substrings. Every iOS browser is one answer: the App Store opens from any of
 * them.
 */
export type Platform = "android" | "ios" | "desktop";

export function detectPlatform(userAgent: string, touchPoints: number): Platform {
  // An iPad on iPadOS 13+ reports itself as a Macintosh. Touch points is what
  // tells it apart from an actual Mac, which has none.
  const ios =
    /iPad|iPhone|iPod/.test(userAgent) || (userAgent.includes("Macintosh") && touchPoints > 1);

  if (ios) return "ios";
  return /Android/.test(userAgent) ? "android" : "desktop";
}
